export default __webpack_public_path__ + "static/media/20_MestMarzipan-Commercial-EschweilerPhotography_21A0413.b6b2d553.jpg";